export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: '/',
  HOME: '/home',
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  AUTHENTICATED_CARE_SERVICES: '/care-services',
  UNAUTHENTICATED_CARE_SERVICES: '/unauthenticated-care-services',
  HEALTH_TOPICS: '/care-services/health-topics',
  PERSONAL_INFO: '/personal-information',
  NOTIFICATIONS: '/notifications',
  PRIVACY_POLICY: '/privacy-policy',
  ABOUT_MY_HEALTH_ALBERTA: '/about',
  MEMBER_REDIRECT: '/member',
  FIND_SUPPORT: '/find-support',
  LIVE_CHAT: '/live-chat',
  CHAT: '/chat',
};

// Preserves the attempted deep-link path+query (e.g. ?modal=chat-support)
// across the Auth0 login redirect, which otherwise returns only to the origin.
export const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirectPath';

// Routes that are never worth restoring after login: they are the login flow
// itself, so capturing one would overwrite the deep link the user came in with
// (e.g. an auth error bounces through /sign-in mid-flow).
export const NON_RESTORABLE_ROUTES = [
  APP_MANAGED_ROUTES.LANDING_PAGE,
  APP_MANAGED_ROUTES.SIGN_IN,
  APP_MANAGED_ROUTES.SIGN_OUT,
];

export const ALLOWED_UNAUTHENTICATED_ROUTES = [
  APP_MANAGED_ROUTES.UNAUTHENTICATED_CARE_SERVICES,
  APP_MANAGED_ROUTES.PRIVACY_POLICY,
  APP_MANAGED_ROUTES.LIVE_CHAT,
];

export const MASONRY_RICH_TEXT_EXTERNAL_LINK_NEW_TAB_ROUTES = [
  APP_MANAGED_ROUTES.PRIVACY_POLICY,
];
